/* eslint-disable jsx-a11y/label-has-associated-control */
import { forwardRef } from "react";

export type LabelProps = JSX.IntrinsicElements["label"];

export const Label = forwardRef<HTMLLabelElement, LabelProps>((props, ref) => {
  const { className = "", ...others } = props;
  return (
    <label
      ref={ref}
      className={`bg-primary text-primary-contrast rounded-t px-3 py-2 ${className}`}
      {...others}
    />
  );
});

Label.displayName = "Label";
